import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultaInteracoesAtendimento } from './types';

export const INITIAL_STATE: ConsultaInteracoesAtendimento = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultaInteracoesAtendimento {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_INTERACOES_ATENDIMENTO_REQUEST: {
				break;
			}
			case Types.CONSULTA_INTERACOES_ATENDIMENTO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.CONSULTA_INTERACOES_ATENDIMENTO_FAILURE: {
				draft.status = 400;
				draft.data = action.payload;
				break;
			}
			case Types.CONSULTA_INTERACOES_ATENDIMENTO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
